import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useParams, useHistory } from 'react-router-dom';

import api from './../../service/api';
import { formatDate, formatCurrency } from './../../service/format';

const StockList = () => {
    let emptyStock = {
        product: '',
        quantity: 0,
    };

    let emptyStockInOut = {
        quantity: null,
        truck: null
    };

    const { code } = useParams();
    const history = useHistory();

    const [trucks, setTrucks] = useState([]);
    const [inOut, setInOut] = useState([]);
    const [stock, setStock] = useState(emptyStock);
    const [stockForm, setStockForm] = useState(emptyStockInOut);
    const [totalIn, setTotalIn] = useState(0);
    const [totalOut, setTotalOut] = useState(0);

    const [stockInDialog, setStockInDialog] = useState(false);
    const [stockOutDialog, setStockOutDialog] = useState(false);
    
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.value) || '';
        let _stock = { ...stockForm };
        _stock[`${name}`] = val;

        setStockForm(_stock);
    }

    const openStock = (type = 'in') => {
        if(type === 'in')  setStockInDialog(true);
        else setStockOutDialog(true);

        setStockForm(emptyStockInOut);
        setSubmitted(false);
        setDisabled(false);
    }

    const hideStock = (type = 'in') => {
        if(type === 'in')  setStockInDialog(false);
        else setStockOutDialog(false);

        setSubmitted(false);
        setDisabled(false);
    }

    const isValidateFields = (type = 'in') => {
        
        if(!stockForm.quantity || (type === 'out' && !stockForm.truck)) 
            return false;
        return true;
    }

    const handleStock = (type = 'in') => {
        if(!isValidateFields(type))
            return setSubmitted(true);
        
        setSubmitted(false);
        setDisabled(true);

        var uri = type === 'in' ? '/stockin/create' : '/stockout/create';
        api().post(uri, {...stockForm, stock: stock.code}).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                hideStock(type);
                listStock();
                listInOut();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const listStock = () => {
        api().get('/stock/' + code).then(response => {
            if(response.status === 200 && response.data.result){
                setStock(response.data.data);
            }
        });
    }

    const listInOut = () => {
        api().get('/stock/inout/' + code).then(response => {
            if(response.status === 200 && response.data.result)
                setInOut(response.data.data);
                var _totalIn = response.data.data.filter(value => value.type === 'Entrada').reduce((previous, current) => previous + current.quantity, 0);
                var _totalOut = response.data.data.filter(value => value.type !== 'Entrada').reduce((previous, current) => previous + current.quantity, 0);
                setTotalIn(_totalIn);
                setTotalOut(_totalOut);
        });
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result)
                setTrucks(response.data.data);
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Entrada de Estoque" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => (openStock())} />
                    <Button label="Saída de Estoque" icon="pi pi-plus" className="p-button-warning mr-2" onClick={() => (openStock('out'))} />
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Voltar" icon="pi pi-arrow-left" className="p-button-info mr-2 float-right" onClick={() => ( history.push('/stock') )} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Estoque - {stock.product}</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (type = 'in') => (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={() => (hideStock(type))} />
            <Button label="Salvar" onClick={() => handleStock(type)} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );

    const formatColumnType = (rowData, text) => {
        return (<span style={{color: rowData.type === 'Entrada' ? 'var(--green-400)' : '#f33030' }}>{text}</span>)
    }

    useEffect(() => {
        if(!code && !Number.isInteger(code)) return history.push('/stock');
        
        listStock();
        listInOut();
        listTrucks();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">{stock.product}</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(stock.quantity)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-box text-blue-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">QTD. Entrada</span>
                            <div className="text-900 font-medium text-xl">{totalIn}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-green-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-arrow-down text-green-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">QTD. Saída</span>
                            <div className="text-900 font-medium text-xl">{totalOut}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-yellow-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-arrow-up text-yellow-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={inOut} 
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem'}}></Column>
                        <Column field="type" body={rowData => formatColumnType(rowData, rowData.type)} header="Tipo" sortable headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="quantity" body={rowData => formatColumnType(rowData, formatCurrency(rowData.quantity))} header="Quantidade" sortable></Column>
                        <Column field='truck' body={(rowData) => (rowData.truck.toUpperCase())} header="Caminhão" sortable></Column>
                        <Column field="createdat" body={rowData => (rowData.createdat ? formatDate(rowData.createdat) : '-')} header="Data" sortable></Column>
                    </DataTable>

                    <Dialog visible={stockInDialog} style={{ width: '450px' }} header="Entrada de Estoque" 
                        modal className="p-fluid" footer={() => (productDialogFooter())} onHide={hideStock}>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="quantityIn">Quantidade</label>
                                <InputNumber value={stockForm.quantity} disabled={disabled} onChange={(e) => onInputChange(e, 'quantity')} id="quantityIn" currency='BRL' maxFractionDigits={2} 
                                mode='decimal' autoFocus />
                                {submitted && !stockForm.quantity && <small className="p-invalid p-error">Informe um quantidade positiva e maior que zero.</small>}
                            </div>
                        </div>
                    </Dialog>

                    <Dialog visible={stockOutDialog} style={{ width: '450px' }} header="Saída de Estoque" 
                        modal className="p-fluid" footer={() => (productDialogFooter('out'))} onHide={() => hideStock('out')}>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="quantity">Quantidade</label>
                                <InputNumber value={stockForm.quantity} disabled={disabled} onChange={(e) => onInputChange(e, 'quantity')} id="quantity" currency='BRL'  maxFractionDigits={2} 
                                mode='decimal' autoFocus />
                                {submitted && !stockForm.quantity && <small className="p-invalid p-error">Informe um quantidade positiva e maior que zero.</small>}
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col s12">
                                <label htmlFor='tolls'>Caminhão</label>
                                <Dropdown value={stockForm.truck}  disabled={disabled} options={trucks} onChange={(e) => onInputChange(e, 'truck')} optionLabel="plate" optionValue='code'  placeholder="Selecione um caminhão" />
                                {submitted && !stockForm.truck && <small className="p-invalid p-error">Escolha um caminhão.</small>}

                            </div>
                        </div>
                    </Dialog>
                    
                </div>
            </div>
        </div>
    );
}

export default StockList;